import { Box, useTheme } from "@mui/material";
import { ReactNode } from "react";

interface ISmartAssistantButton {
  children: JSX.Element | ReactNode;
  bylaw: string;
  onClick: ()=> void;
}

const SmartAssistantButton: React.FC<ISmartAssistantButton>= (props: ISmartAssistantButton) => {
  const { bylaw, onClick, children } = props;
  const theme = useTheme();
  return (
    <Box
      id={'smart-assistant-button'} 
      onClick={onClick} 
      sx={{ 
        display: 'flex',
        fontFamily: 'Oswald',
        alignItems: 'center',
        padding: '0px 8px',
        boxSizing: 'border-box',
        width: '275px', 
        background: bylaw === 'Old' ? theme.palette.common.oldBylawColor : theme.palette.common.newBylawColor,
        height: '35px',
        borderRadius: '4px', 
        fontSize: '16px',
        color: 'black', 
        cursor: 'pointer',
        transition: 'transform 0.3s ease, box-shadow 0.15s ease',
        WebkitTransition: 'transform 0.3s ease, box-shadow 0.15s ease',
        ':hover':{
          transform: 'scale(1.03)',
          background: bylaw === 'Old' ? theme.palette.common.oldBylawHoverColor : theme.palette.common.newBylawHoverColor
        },
      }}>
      {children}
    </Box>
  );
}

export default SmartAssistantButton;